
























import JourneyParameters from '@/models/interfaces/JourneyParameters';
import SurveyAnswer from '@/models/SurveyAnswer';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ContactChannelCheckbox from '@/components/ContactChannelCheckbox.vue';

enum Alignment {
  LEFT = 'left',
  CENTER = 'center',
}

@Component({
  components: {
    ContactChannelCheckbox,
  },
})
export default class ContactChannelCheckboxes extends Vue {
  @Prop() public rating: SurveyAnswer;
  @Prop({ required: true }) public readonly parameters: JourneyParameters;
  @Prop({ default: 'left' }) public readonly alignment: Alignment;

  public get shouldShowContactChannels(): boolean {
    return (
      this.shouldShowContactChannelsForDetractor() ||
      this.shouldShowContactChannelsForNeutral() ||
      this.shouldShowContactChannelsForPromoter()
    );
  }

  public get isCenterAlign(): boolean {
    return this.alignment === Alignment.CENTER;
  }

  public get setTitlePositioning(): string {
    if (this.isCenterAlign) {
      return 'text-center';
    }
  }

  public get setChannelsPositioning(): string {
    if (this.isCenterAlign) {
      return 'center-contacts';
    }
  }

  private shouldShowContactChannelsForDetractor(): boolean {
    return this.rating?.acceptanceContactIfDetractor && this.parameters?.enableInformChannelsIfDetractor;
  }

  private shouldShowContactChannelsForNeutral(): boolean {
    return this.rating?.acceptanceContactIfNeutral && this.parameters?.enableInformChannelsIfNeutral;
  }

  private shouldShowContactChannelsForPromoter(): boolean {
    return this.rating?.acceptanceContactIfPromoter && this.parameters?.enableInformChannelsIfPromoter;
  }
}
